import { IconProps } from "../../../types/style";

const TruckCheck = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 2V12C15.5 13.1 14.6 14 13.5 14H2.5V7.62C3.23 8.49 4.35003 9.03 5.59003 9C6.60003 8.98 7.51 8.59 8.19 7.94C8.5 7.68 8.76002 7.34999 8.96002 6.98999C9.32002 6.37999 9.52 5.65997 9.5 4.90997C9.47 3.73997 8.95001 2.71 8.14001 2H15.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 14V17C22.5 18.66 21.16 20 19.5 20H18.5C18.5 18.9 17.6 18 16.5 18C15.4 18 14.5 18.9 14.5 20H10.5C10.5 18.9 9.6 18 8.5 18C7.4 18 6.5 18.9 6.5 20H5.5C3.84 20 2.5 18.66 2.5 17V14H13.5C14.6 14 15.5 13.1 15.5 12V5H17.34C18.06 5 18.72 5.39001 19.08 6.01001L20.79 9H19.5C18.95 9 18.5 9.45 18.5 10V13C18.5 13.55 18.95 14 19.5 14H22.5Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.5 22C9.60457 22 10.5 21.1046 10.5 20C10.5 18.8954 9.60457 18 8.5 18C7.39543 18 6.5 18.8954 6.5 20C6.5 21.1046 7.39543 22 8.5 22Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 22C17.6046 22 18.5 21.1046 18.5 20C18.5 18.8954 17.6046 18 16.5 18C15.3954 18 14.5 18.8954 14.5 20C14.5 21.1046 15.3954 22 16.5 22Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 12V14H19.5C18.95 14 18.5 13.55 18.5 13V10C18.5 9.45 18.95 9 19.5 9H20.79L22.5 12Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.50017 4.90999C9.52017 5.65999 9.32019 6.38001 8.96019 6.99001C8.76019 7.35001 8.50017 7.68002 8.19017 7.94002C7.51017 8.59002 6.6002 8.98002 5.5902 9.00002C4.3502 9.03002 3.23017 8.49001 2.50017 7.62001C2.36017 7.47001 2.24018 7.30002 2.13018 7.13002C1.74018 6.54002 1.52017 5.84005 1.50017 5.09005C1.47017 3.83005 2.03016 2.68001 2.93016 1.93001C3.61016 1.37001 4.47014 1.02002 5.41014 1.00002C6.46014 0.98002 7.42019 1.36002 8.14019 2.00002C8.95019 2.71002 9.47017 3.73999 9.50017 4.90999Z"
          stroke={color}
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.94043 5.03003L4.95044 5.98999L7.04041 3.96997"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default TruckCheck;
